export default __webpack_public_path__ + "static/media/zawodnik5.ef20f6d1.png";